import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SERVER_URL } from '../server_config';

// Single base API instance. Every endpoint file injects into this one createApi
// (via appApi.injectEndpoints) so that cache tags cross-invalidate across the
// whole app. See refactor-plan.md Phase 7. The tagTypes below are the union of
// every domain's tags; Phase 8 migrates the remaining standalone instances
// (events/customers/users) onto this base.
export const appApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: SERVER_URL,
    credentials: 'include',
  }),
  tagTypes: [
    // event dashboard
    'bracket',
    'Bracket',
    'DivisionPlayers',
    'Event',
    'EventBracketRounds',
    'EventCurrentRound',
    'EventCurrentUserRegistration',
    'EventDivisions',
    'EventFinishedAllMatchesRound',
    'EventGroupsReviewedRound',
    'EventManagerPermissions',
    'EventPlayerLogs',
    'EventPhotos',
    'EventFeedback',
    'InvitationCandidates',
    'EventPlayers',
    'EventPlayersForRound',
    'EventRegistrationForm',
    'EventResults',
    'EventResultsByDivision',
    'EventRobinRounds',
    'EventRoundGroups',
    'EventRounds',
    'EventScoreEntryTokens',
    'Events',
    'EventScoringLogs',
    'EventSimplePlayers',
    'EventTables',
    'EventTypes',
    'Group',
    'GroupConflicts',
    'GroupInstances',
    'GroupLeaderboard',
    'GroupMatches',
    'Instance',
    'Match',
    'Player',
    'PlayerNextMatch',
    'Result',
    'Round',
    'ScoreEntry',
    'RoundBrackets',
    'RoundCanContinue',
    'RoundGroups',
    'RoundQualifiedPlayersCount',
    'Timetable',
    // customers
    'Customer',
    'Customers',
    'Divisions',
    'Leaderboard',
    'Managers',
    'Permissions',
    // auth / users
    'CurrentUser',
    'InvitationConsents',
    'DummyUser',
    'DummyUserMatches',
    'DummyUserMedals',
    'DummyUserNextEvents',
    'DummyUserPossibleCustomers',
    'DummyUserStats',
    'User',
    'UserMatches',
    'UserMedals',
    'UserNextEvents',
    'UserPossibleCustomers',
    'UserStats',
  ],
  endpoints: () => ({}),
});
